import { Component, Input, OnInit } from "@angular/core";
import { LocalStorageManagerService } from "../_services/localStoageManager.service";

@Component({
  moduleId: module.id,
  selector: "text",
  templateUrl: "text.component.html",
})
export class TextComponent implements OnInit {
  @Input() divId: any;
  @Input() type: number; // 1 - div , 2 - p, 3 - h4
  texts: any;
  text: any;

  constructor(private localStorageManager: LocalStorageManagerService) {}

  getTextFromGeneralTexts() {
    if (
      this.divId &&
      this.localStorageManager.getItem("generalTexts") !== "undefined"
    ) {
      let generalTexts = JSON.parse(
        this.localStorageManager.getItem("generalTexts")
      );
      if (generalTexts && generalTexts.length && generalTexts.length > 0) {
        generalTexts.forEach((t) => {
          if (t.divId && t.divId === this.divId) {
            this.text = t.divText;
          }
        });
      }
    }
  }

  getTextFromTexts() {
    if (
      this.divId &&
      this.localStorageManager.getItem("texts") != "undefined"
    ) {
      this.texts = JSON.parse(this.localStorageManager.getItem("texts"));
      if (
        this.texts &&
        this.divId &&
        this.texts[this.divId] &&
        this.texts[this.divId].trim() !== ""
      ) {
        this.text = this.texts[this.divId];
        return true;
      }
    }
    return false;
  }

  ngOnInit() {
    this.type = this.type ? this.type : 1;
    let hasText = this.getTextFromTexts();
    if (!hasText) this.getTextFromGeneralTexts();
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/text.component.ts